import { render } from "./ListeProduit.vue?vue&type=template&id=182fd598&ts=true"
import script from "./ListeProduit.vue?vue&type=script&lang=ts"
export * from "./ListeProduit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__